import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Caravanas from './pages/Caravanas';
import Igrejas from './pages/Igrejas';
import Campos from './pages/Campos';
import Eventos from './pages/Eventos';
import EventoDashboard from './pages/EventoDashboard';
import ResponsaveisCaravana from './pages/ResponsaveisCaravana';
import Quartos from './pages/Quartos';
import Locais from './pages/Locais';
import Caixas from './pages/Caixas';
import PlanosContas from './pages/PlanosContas';
import MovimentacoesCaixa from './pages/MovimentacoesCaixa';
import OcorrenciasTipos from './pages/OcorrenciasTipos';
import Ocorrencias from './pages/Ocorrencias';
import OcorrenciasKanban from './pages/OcorrenciasKanban';
import Alocacoes from './pages/Alocacoes';
import AlocacaoDinamica from './pages/AlocacaoDinamica';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/caravanas" element={<Caravanas />} />
          <Route path="/igrejas" element={<Igrejas />} />
          <Route path="/campos" element={<Campos />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/evento/:id/dashboard" element={<EventoDashboard />} />
          <Route path="/responsaveis-caravana" element={<ResponsaveisCaravana />} />
          <Route path="/quartos" element={<Quartos />} />
          <Route path="/locais" element={<Locais />} />
          <Route path="/alocacoes" element={<Alocacoes />} />
          <Route path="/alocacao-dinamica" element={<AlocacaoDinamica />} />
          <Route path="/caixas" element={<Caixas />} />
          <Route path="/planos-contas" element={<PlanosContas />} />
          <Route path="/movimentacoes-caixa" element={<MovimentacoesCaixa />} />
          <Route path="/ocorrencias-tipos" element={<OcorrenciasTipos />} />
          <Route path="/ocorrencias" element={<Ocorrencias />} />
          <Route path="/ocorrencias-kanban" element={<OcorrenciasKanban />} />
        </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;